module.exports = __webpack_public_path__ + "static/media/empty-profile-image.a5369809.png";